// extracted by mini-css-extract-plugin
export var attachment = "_ox-a";
export var emailContainer = "_ox-4";
export var emailContentPaddedContainer = "_ox-b";
export var emailHeader = "_ox-6";
export var emailIframe = "_ox-3";
export var emailInfoIcon = "_ox-9";
export var emailShortenedSummary = "_ox-e";
export var infoDropdown = "_ox-0";
export var infoRowBoundedContent = "_ox-d";
export var internal = "_ox-5";
export var merchant = "_ox-8";
export var messageInputContainer = "_ox-h";
export var normal = "_ox-7";
export var replyCard = "_ox-f";
export var subtleButton = "_ox-1";
export var subtleButtonIconContainer = "_ox-2";
export var toggleViewRepliesButton = "_ox-c";
export var wrappingText = "_ox-g";